
import { Link } from "react-router-dom";
import GulfStudentsData from "../Data/Gulf_Students/GulfStudentsData";
import PreDepartureTestimonialData from "../Data/Gulf_Students/Testimonial_Data/PreDepartureTestimonialData";
import "../Gulf_Students/CSS/GulfStudentsCSS.css";
import "../Gulf_Students/CSS/ThanksPage.css";
import TestimonialCard from "../Gulf_Students/JS/TestimonialCard";
import PdfFile from "../PDFs/Gulf-Student-Departure-Checklist.pdf";

const PreDepartureToolkitSuccess = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = PdfFile;
    link.download = "Gulf-Student-Departure-Checklist.pdf";
    link.click();
  };
  return (
    <>
      <section className="thank-you-page-main-section">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12 thank-you-page-heading-para-div">
              <h1>Thank you for submitting the request.</h1>
              <h2>You’re All Set for Takeoff!</h2>
              <h4>Your Gulf-to-Study Abroad Departure Checklist is one click away.</h4>
              <button onClick={handleDownload}>Download It Now</button>
              <h2>Want to build academic confidence before you arrive? </h2>
              <h4>Join our free 14-Day Academic Prep Bootcamp.</h4>
              <Link to={"/gulf-students/academic-readiness"}><button>Start Bootcamp</button></Link>
            </div>
          </div>
        </div>
      </section>
      <TestimonialCard data={PreDepartureTestimonialData} title={<><span>Social</span> Proof</>} />
      <section className="other-services-section-start-here">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12 other-services-heading-div">
              <h2>Other <span>Services</span></h2>
            </div>
          </div>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
            {
              GulfStudentsData.filter(item => item.id !== 1)
                .map((item) => {
                  return (
                    <div className="col our-services-card-div" key={item.id}>
                      <div className="our-services-card-inner-div">
                        <div className="what-we-offer-card-icon">
                          <img src={item.bannerImg} alt="" />
                        </div>
                        <h5>{item.heading}</h5>
                        <p>{item.text}</p>
                        {item.link}
                      </div>
                    </div>
                  )
                })
            }
          </div>
        </div>
      </section>
    </>
  )
}

export default PreDepartureToolkitSuccess